<div [ngClass]="variant === 'small' ? 'panel-header panel-header-sm' : 'panel-header'">
  <ng-container [ngSwitch]="variant">
    <ng-container *ngSwitchCase="'small'"></ng-container>

    <ng-container *ngSwitchCase="'logo'">
      <div class="top-banner-logo pt-4">
        <img class="logo-header" src="./assets/img/logos/skylark-control-logo-white.svg" alt="Skylark Dashboard" />
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'title'">
      <div class="header text-center">
        <h2 class="title mb-3">{{ title }}</h2>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'custom'">
      <div class="header text-center">
        <ng-content></ng-content>
      </div>
    </ng-container>
  </ng-container>
</div>
